<template>
  <div class="container d-flex  ai-center jc-around fd-column text-center p-t-5 m-t-5">
    <div class="m-r-1:t" v-if="this.$route.params.justMessage === 'GENERIC-NOT-ELIGILE-PAGE'">
      <p class="p-t-2 p-b-2">We're sorry! This pro's public profile isn't available right now,
      please try again at a later date.</p>
      <ul class="x-reset-list-styles">
        <li><a href="/" class="link">Homepage </a></li>
      </ul>
    </div>
    <div class="m-r-1:t" v-else-if="this.$route.params.justMessage === 'PROS-NOT-ELIGIBLE-PAGE'">
      <p class="p-t-2 p-b-2">We're sorry! Your profile isn't eligible for display right now.
      For help, reach out to <a href="tel:1-855-723-2266" class="link"> 1-855-723-2266 </a>
        or <a href="mailto:support@proreferral.com" class="link"> support@proreferral.com</a>.
        First, please make sure that:</p>
      <div class="p-b-2 POINTS">
        <li>You're fully onboarded</li>
        <li>Your certificates are valid</li>
        <li>Your background check is complete and passed</li>
        <li>You've met all compliances</li>
      </div>
      <ul class="x-reset-list-styles">
        <li><a href="/account/occupation/edit" class="link">Occupations</a></li>
        <li><a href="/" class="link">Homepage </a></li>
      </ul>
    </div>
    <div class="m-r-1:t d-flex fd-column p-t-4 m-x-2" v-else>
      <div class="TITLE">{{ title }}</div>
      <div class="">
        <div v-html="message" class="TEXT"></div>
        <img :src="image" class="IMG">
        <div class="m-b-6">

          <button
              v-if="error === 401"
              class="btn btn-sm"
              @click="$router.push({ name: 'login' })"
          >
            Log into My Account
          </button>
          <router-link
              v-else-if="error != 401"
              class=""
              :class="[isError ? 'btn-sm btn-secondary m-r-3' : 'btn btn-sm']"
              :to="{
                name: 'homepage',
              }"
          >
            Go to Home
          </router-link>

          <button v-if="isError" class="btn btn-sm" @click="reload">Refresh</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { ERROR_CONSTANTS } from './error-constants';

export default {
  name: 'error-generic',
  ERROR_CONSTANTS,
  props: {
    error: {
      type: Number,
      default: null,
    },
  },
  computed: {
    title () {
      return this.$options.ERROR_CONSTANTS[this.error].title;
    },
    message () {
      return this.$options.ERROR_CONSTANTS[this.error].message;
    },
    image () {
      return this.$options.ERROR_CONSTANTS[this.error].image;
    },
    isError () {
      return this.error === 500;
    },
  },
  mounted () {
    const eventDetails = {};
    eventDetails.error = this.error;
    if (Object.prototype.hasOwnProperty.call(this.$route.params, 'redirectedFrom')) {
      eventDetails.redirectedFrom = this.$route.params.redirectedFrom;
    }
    this.$events.$emit(this.$events.ERROR_PAGE_LOAD, eventDetails);
  },
  methods: {
    reload () {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools.scss";

.POINTS {
  justify-content: center;
  text-align: left;
  display: grid
}
.TITLE {
  padding-top: 5 * $unit;
  font-weight: 600;
  font-size: 30px;
  padding-bottom: $unit * 2;

  @include mobile-only() {
      font-size:  24px;
      text-align: left;
      padding-top: 0 * $unit;
  }
}
.TEXT {
  padding-bottom: 6 * $unit;
  font-size:  14px;

  @include mobile-only() {
      text-align: left;
  }
}
.IMG {
  padding-bottom: $unit * 10;
  width: 30 * $unit;

  @include mobile-only() {
    width: 27 * $unit;
  }
}
</style>
